import _StudentGeneralInfo from './model';
import create from './create';

export const StudentGeneralInfo = _StudentGeneralInfo;

StudentGeneralInfo.create = create;

export default StudentGeneralInfo;



// WEBPACK FOOTER //
// ./domain/StudentGeneralInfo/index.js